import {
    AxiosHttpClient,
    Logger,
    ObjectManagementModule, PlatformTypes
} from 'UI-Dash-Commons-UI';
import MediatedNetworkSpec from '../types/MediatedNetworkSpec';
import UserKeySpec from '../types/UserKeySpec';
import MediationSKAdnetworkIdsSpec from '../types/MediationSKAdnetworkIdsSpec';
import SDKChangeSpec from "../types/SDKChangeSpec";

const BASE_REQUEST_URL = '/docs/v1';
const MEDIATED_NETWORKS_REQUEST_URL = `${BASE_REQUEST_URL}/mediated_networks`;
const MEDIATED_SK_ADNETWORK_IDS_REQUEST_URL = `${BASE_REQUEST_URL}/mediation_sk_adnetwork_ids`;
const USER_KEYS_REQUEST_URL = `${BASE_REQUEST_URL}/user_keys`;

export default class MediationDocsManager
    extends ObjectManagementModule.ObjectManagerBase
{
    public loadNetworks(
        reduxSpec: ObjectManagementModule.ObjectDispatchReduxSpec,
    ): void
    {
        this.loadObjectWithRedux<MediatedNetworkSpec[]>(
            MEDIATED_NETWORKS_REQUEST_URL,
            'networks',
            reduxSpec,
            null,
            null
        );
    }

    public loadSKAdnetworkIds(
        reduxSpec: ObjectManagementModule.ObjectDispatchReduxSpec,
    ): void
    {
        this.loadObjectWithRedux<MediationSKAdnetworkIdsSpec[]>(
            MEDIATED_SK_ADNETWORK_IDS_REQUEST_URL,
                'mediationSKAdnetworkIdsSpecs',
            reduxSpec,
            null,
            null
        );
    }

    public loadSdkKey(
        reduxSpec: ObjectManagementModule.ObjectDispatchReduxSpec,
    ): void
    {
        this.loadObjectWithRedux<UserKeySpec>(
            `${USER_KEYS_REQUEST_URL}/sdk`,
            'key',
            reduxSpec,
            null,
            null
        );
    }

    public loadSafedkKey(
        reduxSpec: ObjectManagementModule.ObjectDispatchReduxSpec,
    ): void
    {
        this.loadObjectWithRedux<UserKeySpec>(
            `${USER_KEYS_REQUEST_URL}/safedk`,
            'key',
            reduxSpec,
            null,
            null
        );
    }

    public static async loadChangeLog(platform: PlatformTypes): Promise<SDKChangeSpec[]>
    {
        const requestUrl = `${BASE_REQUEST_URL}/sdk-change-logs/${platform}`;

        Logger.info( 'MediationDocsManager', `Fetching Credentials from ${requestUrl}...` );

        const client: AxiosHttpClient = new AxiosHttpClient();
        const data = await client.get( requestUrl );
        return data.sdkChangeLogs;
    }
}
